// extracted by mini-css-extract-plugin
module.exports = {"option":"SubtitlesLanguageCheckbox-moduleoption2v3","radiobutton":"SubtitlesLanguageCheckbox-moduleradiobuttonR_x","cancelButton":"SubtitlesLanguageCheckbox-modulecancelButton3DJ"};